import React, { useContext, useEffect, useState } from 'react';
import { LovWithoutIdDTO } from '@api/ringil-api.v2';
import { ApiContext } from '@api/api';
import { MultiSelect } from 'primereact/multiselect';

interface CurrencyMultiselectProps {
  selectedCurrencies: string[];
  onSelected: (currencies: string[]) => void;
  disabled?: boolean;
  required?: boolean;
  style?: any;
  code?: string;
  currencies?: LovWithoutIdDTO[];
}

const CurrencyMultiselect: React.FC<CurrencyMultiselectProps> = ({
                                                                   selectedCurrencies,
                                                                   onSelected,
                                                                   style,
                                                                   disabled = false,
                                                                   required = true,
                                                                   code,
                                                                   currencies: passedCurrencies,
                                                                 }) => {
  const { lovCurrency } = useContext(ApiContext);
  const [currencies, setCurrencies] = useState<LovWithoutIdDTO[]>();

  useEffect(() => {
    // Use passed currencies if available, otherwise load from API
    if (passedCurrencies && passedCurrencies.length > 0) {
      setCurrencies(passedCurrencies);
    } else {
      lovCurrency(data => {
        setCurrencies(data);
      }, code);
    }
  }, [passedCurrencies, code, lovCurrency]);

  return (
    <MultiSelect
      options={currencies}
      optionValue={'code'}
      optionLabel={'code'}
      onChange={e => onSelected(e.value)}
      value={selectedCurrencies}
      disabled={disabled}
      style={style || { width: '500px' }}
      showClear={!required}
      filter
    />
  );
};

export default CurrencyMultiselect;
